import { CE_MODAL_CLOSE } from "@js/actions/studio/modals.js";
import { getContent } from "@js/helpers/state.js";

export const CE_MODAL_CONVERT_HTML_TO_TEXT_OPEN =
  "CE_MODAL_CONVERT_HTML_TO_TEXT_OPEN";
export const ceModalConvertHTMLToTextOpen = (clientContentID, connector) => (
  dispatch,
  getState,
) => {
  dispatch({
    type: CE_MODAL_CONVERT_HTML_TO_TEXT_OPEN,
    client_content_id: clientContentID,
  });

  let content = getContent(getState(), clientContentID);
  let startTime = Date.now();
  let minimumTime = 1000;

  convertHtmlToText(content.html, (text, err) => {
    let completionTime = Date.now();
    let timeRemaining = minimumTime - (completionTime - startTime);

    if (err) {
      dispatch(ceModalConvertHTMLToTextError(err));
      return;
    }

    let finish = () => {
      connector.trigger({ type: "replace", value: text });
      dispatch(ceModalConvertHTMLToTextSave(text));
    };

    if (timeRemaining > 0) {
      setTimeout(finish, timeRemaining);
    } else {
      finish();
    }
  });
};

export const CE_MODAL_CONVERT_HTML_TO_TEXT_ERROR =
  "CE_MODAL_CONVERT_HTML_TO_TEXT_ERROR";
export const ceModalConvertHTMLToTextError = (err) => ({
  type: CE_MODAL_CONVERT_HTML_TO_TEXT_ERROR,
  error: err,
});

export const ceModalConvertHTMLToTextClose = () => ({
  type: CE_MODAL_CLOSE,
});

export const CE_MODAL_CONVERT_HTML_TO_TEXT_SAVE =
  "CE_MODAL_CONVERT_HTML_TO_TEXT_SAVE";
export const ceModalConvertHTMLToTextSave = (text) => ({
  type: CE_MODAL_CONVERT_HTML_TO_TEXT_SAVE,
  text: text,
});
